import { Component, Input } from "@angular/core"

@Component({
  selector: "flow-card",
  templateUrl: "./flow-card.component.html",
  styleUrl: "./flow-card.component.scss",
  standalone: false,
})
export class FlowCardComponent {
  @Input() width: string = ""
  @Input() height: string = ""
  @Input() type: FlowCardType = "header"

  constructor() {}
}

export type FlowCardType = "header" | "frame"
